import dayjs from 'dayjs'

const getTimeHour = time => {
	if (!time) return null

	let hour, minute

	if (Array.isArray(time)) {
		;[hour, minute] = time
	} else {
		const split = time.includes(' ') ? time.split(' ')[1].split(':') : time.split(':')
		hour = parseInt(split[0])
		minute = parseInt(split[1])
	}

	const hourFormat = dayjs().hour(hour).minute(minute).format('h:mm a')

	return hourFormat
}

export default getTimeHour
